/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { JoysticksInputs } from "../../../../gen/skills/joysticks_inputs";

export const protobufPackage = "skills";

export interface SpoofJoysticksInputsActionArgs {
  inputs: JoysticksInputs | undefined;
  durationS: number;
}

export interface SpoofJoysticksInputsResultData {
}

export interface SpoofJoysticksInputsActionStateData {
}

function createBaseSpoofJoysticksInputsActionArgs(): SpoofJoysticksInputsActionArgs {
  return { inputs: undefined, durationS: 0 };
}

export const SpoofJoysticksInputsActionArgs = {
  encode(message: SpoofJoysticksInputsActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.inputs !== undefined) {
      JoysticksInputs.encode(message.inputs, writer.uint32(10).fork()).ldelim();
    }
    if (message.durationS !== 0) {
      writer.uint32(21).float(message.durationS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofJoysticksInputsActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofJoysticksInputsActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.inputs = JoysticksInputs.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.durationS = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofJoysticksInputsActionArgs {
    return {
      inputs: isSet(object.inputs) ? JoysticksInputs.fromJSON(object.inputs) : undefined,
      durationS: isSet(object.durationS) ? globalThis.Number(object.durationS) : 0,
    };
  },

  toJSON(message: SpoofJoysticksInputsActionArgs): unknown {
    const obj: any = {};
    if (message.inputs !== undefined) {
      obj.inputs = JoysticksInputs.toJSON(message.inputs);
    }
    if (message.durationS !== 0) {
      obj.durationS = message.durationS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofJoysticksInputsActionArgs>, I>>(base?: I): SpoofJoysticksInputsActionArgs {
    return SpoofJoysticksInputsActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofJoysticksInputsActionArgs>, I>>(
    object: I,
  ): SpoofJoysticksInputsActionArgs {
    const message = createBaseSpoofJoysticksInputsActionArgs();
    message.inputs = (object.inputs !== undefined && object.inputs !== null)
      ? JoysticksInputs.fromPartial(object.inputs)
      : undefined;
    message.durationS = object.durationS ?? 0;
    return message;
  },
};

function createBaseSpoofJoysticksInputsResultData(): SpoofJoysticksInputsResultData {
  return {};
}

export const SpoofJoysticksInputsResultData = {
  encode(_: SpoofJoysticksInputsResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofJoysticksInputsResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofJoysticksInputsResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofJoysticksInputsResultData {
    return {};
  },

  toJSON(_: SpoofJoysticksInputsResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofJoysticksInputsResultData>, I>>(base?: I): SpoofJoysticksInputsResultData {
    return SpoofJoysticksInputsResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofJoysticksInputsResultData>, I>>(_: I): SpoofJoysticksInputsResultData {
    const message = createBaseSpoofJoysticksInputsResultData();
    return message;
  },
};

function createBaseSpoofJoysticksInputsActionStateData(): SpoofJoysticksInputsActionStateData {
  return {};
}

export const SpoofJoysticksInputsActionStateData = {
  encode(_: SpoofJoysticksInputsActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofJoysticksInputsActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofJoysticksInputsActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofJoysticksInputsActionStateData {
    return {};
  },

  toJSON(_: SpoofJoysticksInputsActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofJoysticksInputsActionStateData>, I>>(
    base?: I,
  ): SpoofJoysticksInputsActionStateData {
    return SpoofJoysticksInputsActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofJoysticksInputsActionStateData>, I>>(
    _: I,
  ): SpoofJoysticksInputsActionStateData {
    const message = createBaseSpoofJoysticksInputsActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
